<template>
  <cx-badge :color="badgeColor">{{ badgeLabel }}</cx-badge>
</template>

<script>
import { capitalize } from 'lodash-es';

import { CxBadge } from '~/components/cx';
import { ORG_TYPES } from '~/support/constants';

export const BADGE_COLOR_MAP = {
  [ORG_TYPES.consumer]: 'yellow',
  [ORG_TYPES.partner]: 'orange',
  [ORG_TYPES.supplier]: 'blue',
};

export default {
  name: 'OrgTypeBadge',

  components: { CxBadge },

  props: {
    type: {
      default: '',
      type: String,
    },
  },

  computed: {
    badgeColor() {
      return BADGE_COLOR_MAP[this.type];
    },

    badgeLabel() {
      return capitalize(this.type);
    },
  },
};
</script>
